import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { rewardEndpointIds } from 'root/src/shared/rewards/constants';
export const deleteReservedRewardEndpoint = {
    [rewardEndpointIds.DELETE_RESERVED_REWARD]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                userId: { type: 'string' },
            },
            required: ['dropId', 'userId'],
        },
    },
};
